import { CapitalizeFirstLetter } from '@cdab/headless-components'
import { TdsNavigationTab, TdsNavigationTabs } from '@scania/tegel-react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { NavLink, useLocation, useSearchParams } from 'react-router-dom'
import { SEARCH_PARAM_OPEN_PLEDGES_KEY } from '../audit-point-tabs'

export const PledgeTabs = () => {
  const { t } = useTranslation()
  const location = useLocation()

  const [selectedTabIndex, setSelectedTabIndex] = useState(0)
  const [searchParams] = useSearchParams({
    [SEARCH_PARAM_OPEN_PLEDGES_KEY]: []
  })

  function getLink(path: string) {
    const link = `${path}?${searchParams.toString()}`
    return link
  }

  const tabRoutes = ['general', 'attachments']

  useEffect(() => {
    const currentIndex = tabRoutes.findIndex(route =>
      location.pathname.endsWith(`/${route}`)
    )
    if (currentIndex !== -1) {
      setSelectedTabIndex(currentIndex)
    } else {
      setSelectedTabIndex(0)
    }
  }, [location.pathname])

  return (
    <TdsNavigationTabs selectedIndex={selectedTabIndex}>
      <TdsNavigationTab>
        <NavLink to={getLink('general')}>
          <CapitalizeFirstLetter>{t('general')}</CapitalizeFirstLetter>
        </NavLink>
      </TdsNavigationTab>
      <TdsNavigationTab>
        <NavLink to={getLink('attachments')}>
          <CapitalizeFirstLetter>{t('attachments')}</CapitalizeFirstLetter>
        </NavLink>
      </TdsNavigationTab>
    </TdsNavigationTabs>
  )
}
